import React, { Component } from "react";
import styled from "styled-components";

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8rem 0 5rem 0;

  .audit-title {
    position: relative;
    width: 120rem;
    font-size: 2.8rem;
    font-weight: bold;
    margin-bottom: 4.6rem;

    &::after {
      position: absolute;
      content: "";
      bottom: -1.6rem;
      left: 0;
      width: 6.4rem;
      height: 0.8rem;
      background-image: linear-gradient(to right, #1677ff, #31afff);
    }
  }

  .audit-container {
    width: 120rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    .audit-content {
      width: 28.2rem;
      height: 22.4rem;
      border-radius: 0.4rem;
      box-shadow: 0 0.4rem 1.2rem -0.4rem rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      transition: all 100ms ease-in-out;
      color: #333333;

      &:hover {
        background-color: #1677ff;
        color: #ffffff;
      }

      .audit-name-container {
        height: 6.5rem;
        display: flex;
        align-items: center;
        justify-content: center;

        .audit-name {
          font-size: 1.8rem;
        }
      }
    }
  }
`;

class AuditBlock extends Component {
  handleSubClick = (data) => {
    this.props.history.push(`/signup/${data.id}`);
  };

  render() {
    const { title, subjects } = this.props;

    return (
      <Div>
        <div className="audit-title">{title}</div>
        <div className="audit-container">
          {subjects.map((data, index) => (
            <div
              key={`auditContent-${index}`}
              className="audit-content"
              onClick={() => {
                this.handleSubClick(data);
              }}
            >
              <img src={data.imgUrl} alt="img" />
              <div className="audit-name-container">
                <div className="audit-name">{data.subName}</div>
              </div>
            </div>
          ))}
        </div>
      </Div>
    );
  }
}

export default AuditBlock;
